import React from "react";
import { Card, CardBody } from "reactstrap";
import { createMarkup } from "../../../../utils/commonFn";

export const CancelAlert = ({ statusNote, cancelBy }) => {
  return (
    <Card
      style={{ borderColor: "#fbb4b4", background: "#fff8f8" }}
      className="my-3 dark-card"
    >
      <CardBody>
        <div className="d-flex mb-1">
          <small className="font-weight-bold mr-1">Cancelled By : </small>
          <small>{cancelBy?.fullName}</small>
        </div>
        <div className="d-flex">
          <small className="font-weight-bold d-flex flex-wrap mr-1">
            Reason :
          </small>
          <small dangerouslySetInnerHTML={createMarkup(statusNote)} />
        </div>
      </CardBody>
    </Card>
  );
};
